<template>
  <div class="processing-program-content">
    <div class="processing-program-content-header">
      <a-button type="primary" :loading="loading" @click="save">{{ $t('save') }}</a-button>
    </div>
    <div class="processing-program-content-body">
      <a-alert
        style="margin: 0 8px"
        :message="$t('page_dnc_setting_set_the_file_suffix')"
        type="info"
        show-icon
      />
      <a-row class="processing-program-content-buttons">
        <template v-for="(item, index) in dataSource">
          <a-col :span="4" :key="index">
            <div class="type-button">
              <a-select
                :value="item.value"
                @change="(value) => changeSelect(value, item)"
                style="width: calc(100% - 60px); height: 48px"
              >
                <template v-for="(select, i) in selectList">
                  <a-select-option :key="i" :value="select.value">
                    {{ select.label }}
                  </a-select-option>
                </template>
              </a-select>
              <div class="type-button-delete" @click.stop="onDelete(item.key)">
                {{ $t('delete') }}
              </div>
            </div>
          </a-col>
        </template>
        <a-col v-if="addMore" :span="4">
          <div class="add-type-button" @click.stop="handleAdd">
            <a-icon style="margin-right: 8px" type="plus" />
            {{ $t('page_dnc_setting_add_machining_type') }}
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const tssp = new TenantSettingServiceProxy()

export default {
  data() {
    return {
      dataSource: [],
      selectKeys: [],
      count: 0,
      editId: '',
      selectList: [
        {
          value: 'null',
          label: this.$t('page_dnc_setting_no_suffix')
        },
        {
          value: '.MPF',
          label: '.MPF'
        },
        {
          value: '.SPF',
          label: '.SPF'
        },
        {
          value: '.EIA',
          label: '.EIA'
        },
        {
          value: '.NC',
          label: '.NC'
        }
      ],
      timer: null,
      loading: false
    }
  },
  computed: {
    addMore() {
      return this.dataSource && this.dataSource.length < 5
    }
  },
  created() {
    this.dataSource = []
    this.editId = ''
    const user = getUserInfo()
    const tenantId = user.tenant_id
    tssp.detailCondition('dncSetting', 'dncSetting', '', '', tenantId, '').then((res) => {
      if (res && res.length) {
        const data = res[0]
        this.editId = data.id
        const key = data.paramValue.split(',')
        this.selectKeys = key
        this.dataSource = key.map((item, index) => {
          const value = { value: item, key: index + '' }
          return value
        })
        this.count = this.dataSource.length
      }
    })
  },
  methods: {
    save() {
      this.loading = true
      if (this.dataSource && this.dataSource.length) {
        const value = this.dataSource
          .map((res) => {
            return res.value
          })
          .join(',')
        const user = getUserInfo()
        const tenantId = user.tenant_id
        const dto = {
          paramKey: 'dncSetting',
          paramName: 'dncSetting',
          id: this.editId,
          paramValue: value,
          tenantId: tenantId
        }
        tssp.submit(dto).then(() => {
          this.$message.success(this.$t('save_success'))
        })
      }
      this.timer = setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    changeSelect(value, item) {
      if (this.selectKeys.indexOf(value) != -1) {
        this.$message.warning(this.$t('page_dnc_setting_same_suffix_choose'))
        return
      }
      const newData = this.dataSource
      const target = newData.find((res) => res.key === item.key)
      if (target) {
        this.selectKeys = this.selectKeys.concat(value)
        target['value'] = value
        this.dataSource = newData
      }
    },
    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== key)
    },
    handleAdd() {
      const { count, dataSource } = this
      const newData = {
        key: count + '',
        value: ''
      }
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    }
  }
}
</script>

<style scoped lang="less">
.processing-program-content {
  height: 100%;
  &-header {
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-body {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    background-color: #ffffff;
    border-radius: 2px;
    border: solid 1px #d8d8d8;
    height: calc(100% - 40px);
    padding-top: 8px;
  }
  &-buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .type-button {
    background-color: #ffffff;
    border-radius: 2px;
    border: solid 1px #d8d8d8;
    margin: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &-delete {
      width: 60px;
      height: 48px;
      background-color: #fff1f0;
      border-left: solid 1px #d8d8d8;
      color: #ff5562;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .add-type-button {
    background-color: #ffffff;
    border-radius: 2px;
    border: solid 1px #4a90e2;
    color: #4a90e2;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px;
    cursor: pointer;
  }
  /deep/ .ant-select-selection {
    height: 48px;
    border: 0;
  }
  /deep/ .ant-select-selection__rendered {
    height: 48px;
    line-height: 48px;
  }
}
</style>
